module.exports = __webpack_public_path__ + "img/red_018.a9bc623b.png";